export const GET_APP_VARIABLES_REQUEST = 'GET_APP_VARIABLES_REQUEST';
export const GET_APP_VARIABLES_SUCCESS = 'GET_APP_VARIABLES_SUCCESS';
export const GET_APP_VARIABLES_FAILURE = 'GET_APP_VARIABLES_FAILURE';
